import styled from 'styled-components';
import TextView from '../../TextView';
import { colors } from '../../../utils';

export const EmptyContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 16px;
  margin-top: 8px;
  text-align: center;
  border: 2px dashed ${colors.lightGrey};
  border-radius: 2px;
  background-color: rgb(249, 249, 249);
`;

export const Image = styled.img`
  width: 60px;
  height: 50px;
  margin-bottom: 16px;
`;

export const Message = styled(TextView)`
  font-size: 16px;
  font-weight: 500;
  color: ${colors.darkGrey};
`;
